/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  GetAreasSuccess,
  GetAreasError,
  GetAreasPending,
  UpdateAreaSuccess,
  AreasActionTypes,
  AreasState,
  Area,
  CreateAreaPayload,
  DeleteAreaPending,
  CreateAreaPending,
  UpdateAreaPending,
  CreateAreaError,
  UpdateAreaError,
  DeleteAreaError,
  DeleteAreaSuccess
} from './types';

// Actions
export const actions = {
  getAreas: (payload: { venueId: string }): AreasActionTypes => ({
    type: types.GET_AREAS.REQUEST,
    payload
  }),
  resetAreas: () => ({ type: types.RESET_AREAS }),
  updateArea: (payload: Partial<Area>) => ({
    type: types.UPDATE_AREA.REQUEST,
    payload
  }),
  resetError: () => ({ type: types.RESET_ERROR }),
  createArea: (payload: CreateAreaPayload): AreasActionTypes => ({
    type: types.CREATE_AREA.REQUEST,
    payload
  }),
  deleteArea: (payload: { id: string }): AreasActionTypes => ({
    type: types.DELETE_AREA.REQUEST,
    payload
  })
};

// Initial State
export const initialState: AreasState = {
  areas: [],
  action: {
    success: false,
    pending: false,
    error: null
  }
};

// Reducer
export const reducer = (state: AreasState = initialState, action: AreasActionTypes): AreasState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_AREAS.SUCCESS:
        draft.areas = (action as GetAreasSuccess).payload;
        break;
      case types.CREATE_AREA.SUCCESS:
        draft.action.success = true;
        break;
      case types.DELETE_AREA.SUCCESS: {
        const { id } = (action as DeleteAreaSuccess).payload;
        draft.areas = draft.areas.filter((v) => v.id !== id);
        draft.action.success = true;
        break;
      }
      case types.UPDATE_AREA.SUCCESS:
        draft.action.success = true;
        const payload = (action as UpdateAreaSuccess).payload;
        if (draft.areas.length) {
          const areaIndex = draft.areas.findIndex((a) => a.id === (payload as Area).id);
          if (areaIndex > -1) {
            Object.assign(draft.areas[areaIndex], payload);
          }
        }
        break;
      case types.CREATE_AREA.PENDING:
      case types.UPDATE_AREA.PENDING:
      case types.DELETE_AREA.PENDING:
      case types.GET_AREAS.PENDING:
        draft.action.pending = (
          action as GetAreasPending | CreateAreaPending | UpdateAreaPending | DeleteAreaPending
        ).payload;
        break;
      case types.DELETE_AREA.ERROR:
      case types.UPDATE_AREA.ERROR:
      case types.CREATE_AREA.ERROR:
      case types.GET_AREAS.ERROR:
        draft.action.error = (action as GetAreasError | CreateAreaError | UpdateAreaError | DeleteAreaError).payload;
        break;
      case types.RESET_ERROR:
        draft.action.error = initialState.action.error;
        break;
      case types.RESET_AREAS:
        draft.areas = initialState.areas;
        draft.action = initialState.action;
        break;
    }
  });
};
